import { Text } from '@dd3tech/wiggui/Text'
import { Spinner } from '@dd3tech/wiggui/Spinnner'
import { Flex } from '@dd3tech/wiggui/Flex'
import { useModalAddListStore } from '../../../store'
import { List } from './List'

export const ContainerLists = () => {
  const lists = useModalAddListStore((state) => state?.lists)

  const isLoadingGetLists = useModalAddListStore(
    (state) => state?.isLoadingGetLists
  )

  return (
    <Flex
      dir="col"
      items="center"
      justify="start"
      wFull
      gap="gap-3"
      className="ui-kit-scrollbar h-full max-h-[50vh]"
    >
      {lists &&
        lists?.length > 0 &&
        lists?.map((list, index) => {
          return (
            <List
              listIndex={index}
              list={list}
              key={list?.name + list?.listCode}
            />
          )
        })}
      {!isLoadingGetLists && lists && lists?.length === 0 && (
        <Text>No se encontraron listas</Text>
      )}
      {isLoadingGetLists && <Spinner customBorderColor="border-t-primary" />}
    </Flex>
  )
}
